import { useMutation } from "@tanstack/react-query";
import { EDIT_USER } from "api/dataProviderTypes";
import fetchApi from "api/fetchApi";
import { ApiResponseData } from "api/types";
import { IReturnType } from "hooks/types";
import { SnackbarSeverity } from "hooks/useSnackbar";
import { IUser } from "models/Employee";
import { FieldValues } from "react-hook-form";

type Props = {
  callback?: () => void;
  id: string;
  showSnackbar?: (message: string, severity: SnackbarSeverity) => void;
};

const useEditUserMutation = ({ callback, id, showSnackbar }: Props) => {
  const {
    data: response,
    isLoading,
    isError,
    isFetching,
    isSuccess,
    refetch,
    mutate,
  }: IReturnType<ApiResponseData<IUser>> = useMutation(
    [EDIT_USER],
    ({ payload }: { payload: FieldValues }) => fetchApi(`users`).put(`/${id}`, payload),
    {
      onSuccess: (data) => {
        showSnackbar && showSnackbar("User Updated Successfully", "success");
        callback && callback();
      },
      onError: (error) => {
        showSnackbar("Failed to Update User", "error");
      },
    }
  );
  return { data: response?.data, isLoading, isError, isFetching, isSuccess, mutate, refetch };
};

export default useEditUserMutation;
